import { DEFAULT_IMAGE_SETTINGS } from '../constants'

export const initialImageSettingsState = {
  imageSettings: { ...DEFAULT_IMAGE_SETTINGS },
}
